"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Manifest = void 0;
const _1 = require(".");
class Manifest extends _1.DefaultModel {
    constructor(name, title, description, is_publicly_visible, is_in_root, sources, categories, defaults, max_value, min_value, pop_max, pop_min, populations, ranges, external_uri, _id) {
        super(_id);
        this.name = name;
        this.title = title;
        this.description = description;
        this.is_publicly_visible = is_publicly_visible;
        this.is_in_root = is_in_root;
        this.sources = sources;
        this.categories = categories;
        this.defaults = defaults;
        this.max_value = max_value;
        this.min_value = min_value;
        this.pop_max = pop_max;
        this.pop_min = pop_min;
        this.populations = populations;
        this.ranges = ranges;
        this.external_uri = external_uri;
        this._id = _id;
    }
}
exports.Manifest = Manifest;
//# sourceMappingURL=manifest.model.js.map